import type { JSX } from 'solid-js';
import { renderMarkdown } from '../../lib/markdown';

// `markdown` presenter (arc 101 slice 09) — static agent-authored prose + mermaid.
// Content is UNTRUSTED, so it is rendered through `renderMarkdown`, which strips
// scripts / raw HTML / event handlers / unsafe URLs before it reaches the DOM
// (same sanitize-then-innerHTML posture the marketing docs pipeline uses). A
// markdown widget carries no query — nothing to page.
export function MarkdownWidget(props: { content: string }): JSX.Element {
  // `innerHTML` is safe here: renderMarkdown sanitizes (html:false markdown-it + a
  // DOM allow-list) before it reaches the DOM — see lib/markdown.ts.
  return <div class="dashboard-md" innerHTML={renderMarkdown(props.content)} />;
}
